// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZMykB","comment":"styles_comment__Yk0vf"};